// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1f5Yw","title":"Images90_title__1ZZQH","images":"Images90_images__2Y6hf"};